<template>
	<div class="slider-loader">
		<p class="sl-top">רק רגע...</p>
		<p class="sl-bottom">אנחנו טוענים את המוצרים המומלצים שלך</p>
		<Spinner />
		<div class="bg-img"></div>
	</div>
</template>

<script>
	import Spinner from "../../assets/img/loader-green.svg";

	export default {
		name: "SliderLoader",
		data: function () {
			return {};
		},
		components: {
			Spinner,
		},
	};
</script>

<style lang="sass" scoped>

	.slider-loader
		padding: 1.5rem
		border-radius: 1rem
		background-color: #fff
		box-shadow: 0 0.5rem 1rem 0 rgba(#000, 0.2)
		position: relative

	.bg-img
		position: absolute
		top: 0
		left: 0
		width: 100%
		height: 100%
		opacity: 0.3
		background-image: url('https://images.unsplash.com/photo-1603380381196-148729a0c8e4?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80')
		background-size: cover
		background-position: center center
		transform: rotate(180deg)


	.sl-top
		font-size: 1.15rem
		opacity: 0.7

	.sl-bottom
		font-size: 1rem
		opacity: 0.5
		margin-bottom: 1.5rem

	svg
		width: 8rem
		height: 8rem
	::v-deep path
		stroke: #1e824c
	::v-deep circle
		fill: #1e824c
</style>
